import { onBeforeUnmount } from 'vue'
import { useMessage } from 'naive-ui'
import { useQueryClient } from '@tanstack/vue-query'

interface ApiError extends Error {
  response?: { status?: number; data?: { detail?: string } }
}

// F-I4: polling query на 10s/30s интервале при flaky сети плодит toast каждый
// тик. Дедупим по queryHash + удерживаем 5s окно молчания на ту же query
// чтобы один и тот же endpoint не зашумлял UI.
const _DEDUP_WINDOW_MS = 5000

export function useQueryErrorHandler(): void {
  const message = useMessage()
  const queryClient = useQueryClient()
  const cache = queryClient.getQueryCache()
  const lastShownAt = new Map<string, number>()
  const unsubscribe = cache.subscribe((event) => {
    if (event.type === 'updated' && event.action.type === 'error') {
      // Per-query opt-out: page shows inline error (используется в useDetectionsSearch
      // для 400 invalid regex).
      if (event.query.meta?.silent === true) return
      const err = event.action.error as ApiError
      // 404 — ожидаемое состояние "ресурс не существует"; страница сама показывает empty state.
      if (err?.response?.status === 404) return
      const queryHash = event.query.queryHash
      const now = Date.now()
      const last = lastShownAt.get(queryHash)
      if (last !== undefined && now - last < _DEDUP_WINDOW_MS) return
      lastShownAt.set(queryHash, now)
      const detail = err?.response?.data?.detail || err?.message || 'Ошибка загрузки данных'
      message.error(detail, { duration: 4000 })
    }
  })
  onBeforeUnmount(() => {
    unsubscribe()
    lastShownAt.clear()
  })
}
